import { useEffect, useState } from 'preact/hooks';
import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { DEMOS } from './HelpDemo';
import { Modal } from './Modal';
import { rich } from './rich';

/**
 * Обучение по шагам: одна мысль на экран, живая иллюстрация вместо абзаца текста,
 * сквозной пример, короткие формулировки. Стрелками ←/→ можно листать с клавиатуры.
 */
export function HelpModal() {
  const c = useController();
  const [step, setStep] = useState(0);
  const last = t.help.steps.length - 1;
  const close = () => c.closeModal();
  const go = (delta: number) => setStep((s) => Math.min(last, Math.max(0, s + delta)));

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  });

  const info = t.help.steps[step];
  const Demo = DEMOS[step];
  if (!info || !Demo) return null;
  const rules = 'rules' in info ? info.rules : null;

  return (
    <Modal labelId="help-title" onClose={close}>
      <div class="help-head">
        <h2 id="help-title">{t.help.title}</h2>
        <span class="help-progress" role="status" data-testid="help-progress">
          {t.help.progress(step + 1, last + 1)}
        </span>
      </div>

      {/* key: при смене шага иллюстрация монтируется заново и анимация играет с начала */}
      <div aria-hidden="true" key={step}>
        <Demo />
      </div>

      <h3 class="help-title" data-testid="help-step-title">
        {info.title}
      </h3>
      <p class="help-text">{rich(info.text)}</p>
      {rules && <p class="help-rules">{rules}</p>}

      <div class="dots" aria-hidden="true">
        {t.help.steps.map((s, i) => (
          <i key={s.title} class={i === step ? 'on' : i < step ? 'seen' : ''} />
        ))}
      </div>

      <div class="btns help-btns">
        {step > 0 && (
          <button type="button" onClick={() => go(-1)}>
            {t.help.back}
          </button>
        )}
        {step < last ? (
          <>
            <button type="button" class="primary" onClick={() => go(1)}>
              {t.help.next}
            </button>
            <button type="button" class="link" onClick={close}>
              {t.help.skip}
            </button>
          </>
        ) : (
          <button type="button" class="primary" onClick={close}>
            {t.help.play}
          </button>
        )}
      </div>
    </Modal>
  );
}
